import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: "page",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(
        /*  webpackChunkName: "login-page-configuration" */ "./components/LoginPageConfiguration"
      ),
      import("./modules/LoginPageConfigurationModule"),
    ])
      .then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const loginPageConfigurationReducer = importedModule1.default;

        injectReducer(store, {
          key: importedModule1.NAME,
          reducer: loginPageConfigurationReducer,
        });

        return component;
      })
      .catch(err => {
        throw err;
      })
  ),
});
